"use strict";

var screenersImport = require("../../screeners");

var utils = require("../../screeners/utils");

var surveyscreeners = [utils.screeners.STRESS];
var questions = screenersImport.expandscreeners([].concat(surveyscreeners));

var analysis = function analysis(answers, numeric) {
  if (!answers) return null;
  var results = {};
  results.scales = {};
  results.humanReadable = {};
  surveyscreeners.forEach(function (battery) {
    var batteryResults = screenersImport.extractResults(questions, answers, battery);
    var scales = screenersImport.getScalesByBatteryId(battery);

    if (scales) {
      results.scales = Object.assign(results.scales, scales);
    }

    var batteryHumanReadable = batteryResults.humanReadable;
    delete batteryResults.humanReadable;
    results = Object.assign(results, batteryResults);
    results.humanReadable = Object.assign(results.humanReadable, batteryHumanReadable);
    results;
  });
  questions.forEach(function (q, i) {
    if (!q.key) return;

    if (numeric) {
      results[q.key] = answers[i];
    } else {
      results[q.key] = q.eval(answers[i], q);
      results.humanReadable[q.prompt] = q.eval(answers[i], q);
    }
  });
  return results;
};

module.exports = {
  questions: questions,
  analysis: analysis
};